export const CLINICAL_RECORD_STATUS = {
  DRAFT: 'DRAFT',
  FINISHED: 'FINISHED'
}

export const EVENT_TYPE = {
  CHANNEL: 'CHANNEL',
  SCHEDULING: 'SCHEDULING',
  TEST_RESULT: 'TEST_RESULT',
  WANDA_TASK: 'WANDA_TASK'
}

export const DISCARD_TYPES = {
  WRONG_APPOINTMENT_TYPE: 'WRONG_APPOINTMENT_TYPE',
  NO_SHOW: 'NO_SHOW',
  LATE_CANCEL: 'LATE_CANCEL',
  OTHER: 'OTHER'
}

const discardOptionsTypes = {
  WRONG_APPOINTMENT_TYPE: {
    label: 'Abri o tipo de consulta errado',
    type: 'WRONG_APPOINTMENT_TYPE'
  },
  NO_SHOW: {
    label: 'O membro não apareceu',
    type: 'NO_SHOW'
  },
  LATE_CANCEL: {
    label: 'O membro desmarcou a consulta',
    type: 'LATE_CANCEL'
  },
  OTHER: {
    label: 'Outro (especifique):',
    type: 'OTHER'
  }
}

export const DELETE_OPTIONS = Object.values(discardOptionsTypes)
export const TIME_TO_UPDATE = 5000

export const EVENT_OPTIONS = [
  {
    label: 'Ver canais ativos',
    description: 'Vincule este registro com um canal',
    type: EVENT_TYPE.CHANNEL
  },
  {
    label: 'Ver agendamentos abertos',
    description: 'Vincule este registro com um agendamento',
    type: EVENT_TYPE.SCHEDULING
  },
  {
    label: 'Ver resultados de exames',
    description: 'Vincule este registro com um exame',
    type: EVENT_TYPE.TEST_RESULT
  },
  {
    label: 'Ver tarefas da wanda',
    description: 'Vincule este registro com tarefas da wanda',
    type: EVENT_TYPE.WANDA_TASK
  }
]

export const EVENT_LABEL = {
  [EVENT_TYPE.CHANNEL]: 'Canais ativos',
  [EVENT_TYPE.SCHEDULING]: 'Agendamentos abertos',
  [EVENT_TYPE.TEST_RESULT]: 'Resultado de exames',
  [EVENT_TYPE.WANDA_TASK]: 'Tarefas da wanda'
}

export const LOG_ACTIONS = {
  WIDGET: 'open_widget_commands',
  ORIGIN: 'clinical_record_origin',
  MACROS: 'macros',
  CID_CIAP: 'cidciap'
}

export const LOG_ACTIONS_AUTOFILL = {
  GENERATE: 'generate_autofill',
  IGNORE: 'ignore_autofill',
  REVIEW: 'review_completed',
  GENERATE_AGAIN: 'regenerate_autofill',
  FAIL: 'autofill_fail',
  FAIL_TRY_AGAIN: 'try_again_after_fail',
  FAIL_CLOSE: 'close_after_fail',
  SUCCESS: 'autofill_generate_success',
  STOP_GENERATING: 'stop_generate_content'
}

export const LOG_ORIGIN = {
  CHANNEL: 'channel',
  SCHEDULING: 'scheduling',
  MANUAL: 'manual'
}

export const TREATED_BY_OPTIONS = [
  {
    key: 'SCREENING_NURSE',
    value: 'Enfermeiro(a) Acolhimento'
  },
  {
    key: 'CLINICAL_NURSE',
    value: 'Enfermeiro(a) Clínico'
  },
  {
    key: 'NURSE_SHARED_WITH_PHYSICIAN',
    value: 'Enfermeiro(a) + compartilhamento do caso com médico(a) Alice Agora'
  },
  {
    key: 'NURSE_CONFERENCE_WITH_PHYSICIAN',
    value: 'Enfermeiro(a) + teleconsulta com médico(a) Alice Agora'
  },
  {
    key: 'PHYSICIAN',
    value: 'Somente médico(a)'
  },
  {
    key: 'NURSE_AND_HEALTH_COMMUNITY',
    value: 'Enfermeiro(a) + matriciamento ou discussão do caso com especialista'
  },
  {
    key: 'NURSE_PHYSICIAN_AND_HEALTH_COMMUNITY',
    value:
      'Enfermeiro(a) + médico(a) Alice Agora + matriciamento ou discussão do caso com especialista'
  }
]

export const ALARM_SIGNAL = 'ALARM_SIGNAL'
export const SYMPTOMS = 'SYMPTOMS'
export const FREE_TEXT = 'FREE_TEXT'

export const CLINICAL_RECORD_TYPE = {
  IMMERSION: 'IMMERSION',
  FOLLOW_UP_VISIT: 'FOLLOW_UP_VISIT',
  ASSISTANCE_CARE: 'ASSISTANCE_CARE',
  HEALTH_PLAN_CARE: 'HEALTH_PLAN_CARE',
  STATEMENT_OF_HEALTH: 'STATEMENT_OF_HEALTH',
  ANNOTATION: 'ANNOTATION',
  DEFAULT: 'DEFAULT',
  COUNTER_REFERRAL: 'COUNTER_REFERRAL',
  ON_SITE: 'ON_SITE',
  TEST_COLLECT: 'TEST_COLLECT',
  EMERGENCY_ROOM: 'EMERGENCY_ROOM',
  TIT_EMERGENCY: 'TIT_EMERGENCY',
  HOSPITALIZATION: 'HOSPITALIZATION',
  TIT_HOSPITALIZATION: 'TIT_HOSPITALIZATION',
  SURGERY: 'SURGERY',
  TIT_SURGERY: 'TIT_SURGERY'
}
